import { render, staticRenderFns } from "./pattern-suggestions-list.vue?vue&type=template&id=762ba678&"
import script from "./pattern-suggestions-list.vue?vue&type=script&lang=js&"
export * from "./pattern-suggestions-list.vue?vue&type=script&lang=js&"
import style0 from "./pattern-suggestions-list.vue?vue&type=style&index=0&id=762ba678&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports